export const permissions = [
  'ADMIN_READ',
  'ADMIN_WRITE',
  'LOG_READ',
  'LOG_READ_TASK',
  'LOG_WRITE',
  'WORKER_READ',
  'WORKER_WRITE',
  'DEPARTMENT_READ',
  'DEPARTMENT_WRITE',
  'PROJECT_READ',
  'PROJECT_WRITE',
  'STATISTICS_READ',
  'WEEKENDS_WRITE',
  'JOURNAL_READ',
  'JOURNAL_READ_DIFF',
  'FILE_WRITE',
  'SETTINGS_WRITE',
].reduce((acc, value) => ({ ...acc, [value]: value }), {});

export const permissionTitles = {
  [permissions.ADMIN_READ]: 'Просмотр администраторов',
  [permissions.ADMIN_WRITE]: 'Создание, редактирование и удаление администраторов',
  [permissions.LOG_READ]: 'Просмотр лога трудозатрат',
  [permissions.LOG_READ_TASK]: 'Просмотр текста задачи в трудозатратах',
  [permissions.LOG_WRITE]: 'Создание, редактирование и удаление трудозатрат',
  [permissions.WORKER_READ]: 'Просмотр сотрудников',
  [permissions.WORKER_WRITE]: 'Редактирование сотрудников',
  [permissions.DEPARTMENT_READ]: 'Просмотр департаментов',
  [permissions.DEPARTMENT_WRITE]: 'Создание, редактирование и удаление департаментов',
  [permissions.PROJECT_READ]: 'Просмотр проектов',
  [permissions.PROJECT_WRITE]: 'Создание, редактирование и удаление проектов',
  [permissions.STATISTICS_READ]: 'Просмотр статистики',
  [permissions.WEEKENDS_WRITE]: 'Редактирование производственного календаря',
  [permissions.JOURNAL_READ]: 'Просмотр журнала событий',
  [permissions.JOURNAL_READ_DIFF]: 'Просмотр изменений в журнале событий',
  [permissions.FILE_WRITE]: 'Управление файлами',
  [permissions.SETTINGS_WRITE]: 'Управление настройками',
};

export const menuLinks = [
  {
    to: '/statistics',
    content: 'Сводка',
    permission: permissions.STATISTICS_READ,
  },
  {
    to: '/logs',
    content: 'Лог',
    permission: permissions.LOG_READ,
  },
  {
    to: '/workers',
    content: 'Сотрудники',
    permission: permissions.WORKER_READ,
  },
  {
    to: '/departments',
    content: 'Департаменты',
    permission: permissions.DEPARTMENT_READ,
  },
  {
    to: '/projects',
    content: 'Проекты',
    permission: permissions.PROJECT_READ,
  },
  {
    to: '/admins',
    content: 'Администраторы',
    permission: permissions.ADMIN_READ,
  },
  {
    to: '/settings/weekends',
    content: 'Календарь',
    permission: permissions.WEEKENDS_WRITE,
  },
  {
    to: '/journal',
    content: 'Журнал',
    permission: permissions.JOURNAL_READ,
  },
];

export const colorsCategorical = [
  '#1f77b4',
  '#ff7f0e',
  '#2ca02c',
  '#d62728',
  '#9467bd',
  '#8c564b',
  '#e377c2',
  '#7f7f7f',
  '#bcbd22',
  '#17becf',
];

export const colorsProjects = [
  ...colorsCategorical,
  '#8a0083',
  '#009e84',
  '#7eff5e',
  '#8400ff',
  '#0091a1',
];

export default {
  permissions,
  permissionTitles,
  menuLinks,
  colorsCategorical,
  colorsProjects,
};
